const MyAppointmentCardLoader = () => {
  return (
    <div className="border-primary-bg flex w-full items-center rounded-lg border bg-white px-6 py-4 transition-all">
      <div className="border-primary-bg w-fit border-e-2 pe-6 text-center">
        <div className="mb-2 h-4 w-6 animate-pulse rounded-md bg-gray-400" />
        <div className="mb-2 h-8 w-8 animate-pulse rounded-md bg-gray-400" />
        <div className="mb-2 h-4 w-6 animate-pulse rounded-md bg-gray-400" />
      </div>
      <div className="ms-4 flex w-full flex-wrap items-center justify-between gap-y-4">
        <div className="flex gap-4 ps-4">
          <div className="mb-2 h-16 w-14 animate-pulse rounded-lg bg-gray-400" />
          <div className="flex flex-col justify-center gap-1 lg:min-w-[10rem] xl:min-w-[11rem]">
            <div className="mb-2 h-4 w-20 animate-pulse rounded-md bg-gray-400" />
            <div className="mb-2 h-4 w-40 animate-pulse rounded-md bg-gray-400" />
          </div>
        </div>
        <div className="flex flex-col">
          <div className="mb-2 h-4 w-20 animate-pulse rounded-md bg-gray-400" />
        </div>

        <div className="mb-2 h-4 w-20 animate-pulse rounded-md bg-gray-400" />
      </div>
    </div>
  );
};

export default MyAppointmentCardLoader;
